import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import { ExpandableContent } from '../../components/global/ExpandableContent/ExpandableContent';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

function PdpSharedDescriptionAdditionalOptionsComponent(props) {
    const { headerClass, contentClass, wrapperClass, item } = props;
    const { isCustomizable } = item;
    const customizationOptions = get(item, 'attributes.customizable[0].text');

    if (!isCustomizable || !customizationOptions) {
        return null;
    }

    return (
        <div
            data-tn="pdp-item-description-customization-options"
            className={classNames(styles.wrapper, wrapperClass)}
        >
            <h2 className={classNames(styles.header, headerClass)}>
                <FormattedMessage
                    id="PdpSharedDescriptionAdditionalOptions.customizationHeader"
                    defaultMessage="Additional Options"
                />
            </h2>
            <ExpandableContent buttonClassName={styles.button}>
                <span className={classNames(styles.content, contentClass)}>
                    {customizationOptions}
                </span>
            </ExpandableContent>
        </div>
    );
}

PdpSharedDescriptionAdditionalOptionsComponent.propTypes = {
    wrapperClass: PropTypes.string,
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDescriptionAdditionalOptions = createFragmentContainer(
    PdpSharedDescriptionAdditionalOptionsComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_item on Item {
                isCustomizable
                attributes {
                    customizable {
                        text
                    }
                }
            }
        `,
    }
);
